import EventEmitter from 'eventemitter3';

export const event = new EventEmitter();
